import fornitoriManager from "../api/FornitoriManager";
import {TipoRigaPreventivo} from "@/types";
import getDocumentElement from "@popperjs/core/lib/dom-utils/getDocumentElement";

const SottoprogettoDataManager = {
    namespaced: true,
    state: () => ({
        sottoprogetto: null,
        dati_sottoprogetto: null,
        fornitore_id: null,
        valute: [],
        fees: [],
        stati_offerta: [
            {id: 0, descrizione: 'Stima', class: "text-next-pre"},
            {id: 1, descrizione: 'Da verificare', class: "text-next-orange"},
            {id: 2, descrizione: 'Consuntivato', class: "text-next-bri"},
        ],
        tipologia: [
            {id:0, descrizione: "Ideazione - evento", class:""},
            {id:1, descrizione: "Personale - evento", class:""},
            {id:2, descrizione: "Produzione - evento", class:""},
            {id:3, descrizione: "Contenuti - evento", class:""},
            {id:4, descrizione: "Locations - evento", class:""},
            {id:5, descrizione: "Altro - evento", class:""},

            {id:6, descrizione: "Ideazione - comunicazione", class:""},
            {id:7, descrizione: "PM - comunicazione", class:""},
            {id:8, descrizione: "Produzione - comunicazione", class:""},
            {id:9, descrizione: "Stampa - comunicazione", class:""},
            {id:10, descrizione: "Media - comunicazione", class:""},
            {id:11, descrizione: "Altro - comunicazione", class:""},

            {id:12, descrizione: "Ideazione - evento integrato", class:""},
            {id:13, descrizione: "Personale - evento integrato", class:""},
            {id:14, descrizione: "Produzione - evento integrato", class:""},
            {id:15, descrizione: "Contenuti - evento integrato", class:""},
            {id:16, descrizione: "Locations - evento integrato", class:""},

            {id:17, descrizione: "Ideazione - Digital", class:""},
            {id:18, descrizione: "PM - Digital", class:""},
            {id:19, descrizione: "Produzione - Digital", class:""},
            {id:20, descrizione: "Media - Digital", class:""},
            {id:21, descrizione: "Altro - Digital", class:""},
        ],
    }),
    mutations: {
        setSottoprogetto: (state: any, val: any) => {
            state.sottoprogetto = val
        },
        setDatiSottoprogetto: (state: any, val: any) => {
            state.dati_sottoprogetto = val
        },
        setFornitoreId: (state: any, id: any) => {
            state.fornitore_id = id
        },
        setValute(state: any, val: any[]) {
            state.valute = val
        },
        setFees(state: any, val: any[]) {
            state.fees = val
        },
    },
    actions: {
        //@ts-ignore
        setSottoprogetto: ({commit}, val) => {
            commit('setSottoprogetto', val)
        },
        //@ts-ignore
        setDatiSottoprogetto: ({commit}, val) => {
            commit('setDatiSottoprogetto', val)
            commit('setFees', val.fee)
            commit('setValute', val.valute)
        },
        //@ts-ignore
        setFornitoreId: ({commit}, val) => {
            commit('setFornitoreId', val)
        },
        //@ts-ignore
        setValute({commit}, valute) {
            commit('setValute', valute)
        },
        //@ts-ignore
        setFees({commit}, fees) {
            commit('setFees', fees)
        },
        prepareDataForODA: ({rootGetters, getters}: any) => {
            return getters.RecordSfusiAcquisto.map((rec: any) => {
                rec['_ac_valuta'] = getters.getValuta(rec.ac_valuta)
                rec['_ac_costo_totale'] = getters.AcCostoTotaleEuro(rec)
                rec['_ve_valuta'] = getters.getValuta(rec.ve_valuta)
                return rec
            })
        },
        selectedRowsGroupByIva: ({getters}: any) => {
            // qui schiaccio le singole righe delle ive in un unico record con indice quello dell'iva
            const ret: any = {
                valuta: null,
                righe: []
            }
            const keys = Object.keys(getters.SelectedRowsPerIva);

            for (let i = 0; i < keys.length; i++) {
                const row = {
                    iva_id: keys[i],
                    iva: {},
                    tot: 0
                }
                row.tot = getters.SelectedRowsPerIva[keys[i]].reduce((acc: number, el: any) => {
                    acc += el._ac_costo_totale
                    row.iva = {...row.iva, ...el.ac_aliquota}
                    if (ret.valuta) {
                        if (ret.valuta?.id != el._ac_valuta?.id) {
                            throw 'Impossibile aggregare righe con valuta differente per la stessa IVA di acquisto'
                        }
                    } else {
                        ret.valuta = el._ac_valuta
                    }
                    return acc
                }, 0)
                ret.righe.push(row)
            }
            return ret
        },
        retrieveData: async ({dispatch}: any) => {
            await dispatch('prepareDataForODA')
            return await dispatch('selectedRowsGroupByIva')
        }
    },
    getters: {
        StatiOfferta: (state: any) => {
            return state.stati_offerta
        },
        Tipologia: (state: any) => {
            return state.tipologia
        },
        StessaValutaAcquisto: (state: any, getters: any) => {
            let first: any = null
            return getters.RecordSfusiAcquisto.every((value: any, index: number) => {
                if (index == 0) {
                    first = value.ac_valuta
                }
                return first == value.ac_valuta
            })
        },
        Sconto: (state: any, getters: any) => {
            return state.dati_sottoprogetto?.sconto || 0
        },
        ValutaAcquisto: (state: any, getters: any) => {
            if (getters.StessaValutaAcquisto && getters.RecordSfusiAcquisto.length) {
                return getters.getValuta(getters.RecordSfusiAcquisto[0].ac_valuta)
            }
            return null;
        },
        valoreValuta: (state: any, getters: any) => (id: number) => {
            const v = getters.getValuta(id)
            if (v) {
                return v.valore
            }
            return 1
        },
        getValuta: (state: any) => (id: string) => {
            return state?.dati_sottoprogetto?.valute?.find((el: any) => el.id == id)
        },
        Sottoprogetto: (state: any) => {
            return state.sottoprogetto
        },
        DatiSottoprogetto: (state: any) => {
            return state.dati_sottoprogetto
        },
        ActiveTab: (state: any) => {
            if (state.dati_sottoprogetto) {
                return state.dati_sottoprogetto.tabs[state.dati_sottoprogetto.active_tab]
            }
            return null
        },
        RecordSfusi: (state: any, getters: any): any[] => {
            if (getters.ActiveTab) {
                return getters.ActiveTab.sezioni.reduce((accumulator: any[], s: any) => {
                    s.records.forEach((r: any) => {
                        if(!getters.isDescrizione(r) && !getters.isOpzionale(r)){
                            if (r.nuvole) {
                                accumulator.push(...r.nuvole)
                            } else {
                                accumulator.push(r)
                            }
                        }
                    })
                    return accumulator
                }, [])
            }
            return []
        },
        RecordSfusiAcquisto: (state: any, getters: any): any[] => {
            return getters.RecordSfusi.filter((r: any) => {
                return r.ne_fornitore?.id == state.fornitore_id
            })
        },
        AliquoteAcquisto: (state: any, getters: any) => {
            return getters.RecordSfusiAcquisto.reduce((acc: any, r: any) => {
                acc[r?.ac_aliquota?.id] = r?.ac_aliquota
                return acc
            }, {})
        },
        AliquoteVendita: (state: any, getters: any) => {
            return getters.RecordSfusi.reduce((acc: any, r: any) => {
                if (r.ve_aliquota) {
                    acc[r?.ve_aliquota?.id] = r?.ve_aliquota
                }
                return acc
            }, {})
        },
        AliquoteVenditaArray: (state: any, getters: any) => {
            const ret = []
            for (let i in getters.AliquoteVendita) {
                ret.push(getters.AliquoteVendita[i])
            }
            return ret
        },
        SelectedRows: (state: any, getters: any) => {
            return getters.RecordSfusiAcquisto;
        },
        RecordPerIvaAcquisto: (state: any, getters: any) => {
            return getters.RecordSfusiAcquisto.reduce((accumulator: any, r: any) => {
                if (r?.ac_aliquota) {
                    (accumulator[r.ac_aliquota.id] = accumulator[r.ac_aliquota.id] || []).push(r);
                } else {
                    (accumulator['unknown'] = accumulator['unknown'] || []).push(r);
                }
                return accumulator;
            }, {})
        },
        RecordPerIvaVendita: (state: any, getters: any) => {
            return getters.RecordSfusi.reduce((accumulator: any, r: any) => {
                if (r?.ve_aliquota) {
                    (accumulator[r.ve_aliquota.id] = accumulator[r.ve_aliquota.id] || []).push(r);
                } else {
                    (accumulator['unknown'] = accumulator['unknown'] || []).push(r);
                }
                return accumulator;
            }, {})
        },
        TotalizzatoriIva: (state: any, getters: any) => {
            const ret: any = {}
            const rpi = getters.RecordPerIvaVendita
            for (let i in rpi) {
                ret[i] = {
                    totale_costi: getters.TotaleCostiEuroProgetto([{records: rpi[i]}]),
                    totale_ricavi: getters.TotaleBudgetProgetto([{records: rpi[i]}]),
                    totale_utili: getters.TotaleUtiliProgetto([{records: rpi[i]}]),
                    ...getters.AliquoteVendita[i]
                }
            }
            return ret
        },
        SelectedRowsPerIva: (state: any, getters: any) => {
            return getters.SelectedRows.reduce((accumulator: any, r: any) => {
                if (r?.ac_aliquota) {
                    (accumulator[r.ac_aliquota.id] = accumulator[r.ac_aliquota.id] || []).push(r);
                } else {
                    (accumulator['unknown'] = accumulator['unknown'] || []).push(r);
                }
                return accumulator;
            }, {})
        },
        AcIsRisorsa: (state: any, getters: any) => (row: any) => {
            return Number(row['ac_costo_unitario_risorsa_interna']) || false
        },
        AcQuantita:(state:any, getters:any) => (row: any) => {
            return  (row['ac_unita'] ?? 1) * (row['ac_ovn_gg'] ?? 1) * (row['ac_qta'] ?? 1)
        },
        VeQuantita:(state:any, getters:any) => (row: any) => {
            return  (row['ve_unita'] ?? 1) * (row['ve_ovn_gg'] ?? 1) * (row['ve_qta'] ?? 1)
        },
        AcCostoUnitario: (state: any, getters: any) => (row: any) => {
            return Number((row['ac_costo_unitario'] ?? 0))
        },
        TotaleOreRisorsa:(state: any, getters: any) => (row: any) => {
            if(getters.AcIsRisorsa(row)){
                return getters.AcQuantita(row)
            }
            return 0
        },
        AcMarkUp: (state: any, getters: any) => (row: any) => {
            return Number((row['ac_mark_up'] ?? 0))
        },
        AcArrotondamentoCostoUnitario: (state: any, getters: any) => (row: any) => {
            return Number((row['ac_arrotondamento_costo_unitario'] ?? 0))
        },
        AcCommissionePercentuale: (state: any, getters: any) => (row: any) => {
            return Number((row['ac_commissione'] ?? 0))
        },
        AcCostoUnitarioNetto: (state: any, getters: any) => (row: any) => {
            return getters.AcCostoUnitario(row) * (1 - getters.AcCommissionePercentuale(row) / 100)
        },
        AcCostoTotale: (state: any, getters: any) => (row: any) => {
            if (row.nuvole) {
                return row.nuvole.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                    return prev_val + getters.AcCostoTotale(curr_row)
                }, 0)
            }
            return getters.AcCostoUnitario(row) * getters.AcQuantita(row)
        },
        AcCostoTotaleEuro: (state: any, getters: any) => (row: any) => {
            return getters.AcCostoTotale(row) * getters.valoreValuta(row['ac_valuta'])
        },
        AcCostoUnitarioEuro: (state: any, getters: any) => (row: any) => {
            return getters.AcCostoUnitario(row) * getters.valoreValuta(row['ac_valuta'])
        },
        AcCostoUnitarioRisorsa: (state: any, getters: any) => (row: any) => {
            return (row['ac_costo_unitario_risorsa_interna'] ?? 0)
        },
        AcCostoTotaleRisorsa: (state: any, getters: any) => (row: any) => {
            return getters.AcCostoUnitarioRisorsa(row) * getters.AcQuantita(row)
        },
        // VeCostoUnitarioRisorsa: (state: any, getters: any) => (row: any) => {
        //     return (row['ve_costo_unitario_risorsa_interna'] ?? 0)
        // },
        // VeCostoTotaleRisorsa: (state: any, getters: any) => (row: any) => {
        //     return getters.VeCostoUnitarioRisorsa(row) * getters.VeQuantita(row)
        // },
        VeBudget: (state: any, getters: any) => (row: any) => {
            if (row.nuvole) {
                return row.nuvole.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                    return prev_val + getters.VeBudget(curr_row)
                }, 0)
            }
            return (getters.CostoVenditaUnitario(row)) * getters.VeQuantita(row)
        },
        VeBudgetEuro: (state: any, getters: any) => (row: any) => {
            if (row.nuvole) {
                return row.nuvole.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                    return prev_val + getters.VeBudgetEuro(curr_row)
                }, 0)
            }
            return (getters.CostoVenditaUnitario(row)) * getters.VeQuantita(row) * getters.valoreValuta(row['ve_valuta'])
        },
        AcCommissioneTotale: (state: any, getters: any) => (row: any) => {
            if (row['ac_commissione']) {
                return getters.AcCostoTotale(row) * (1 - getters.AcCommissionePercentuale(row) / 100)
            }
            return 0
        },
        AcCommissioneTotaleEuro: (state: any, getters: any) => (row: any) => {
            if (getters.AcCommissionePercentuale(row)) {
                return getters.AcCostoTotaleEuro(row) * getters.AcCommissionePercentuale(row) / 100
            }
            return 0
        },
        BudgetLordoIva: (state: any, getters: any) => (row: any) => {
            if (row.nuvole) {
                return row.nuvole.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                    return prev_val + getters.BudgetLordoIva(curr_row)
                }, 0)
            }
            return getters.VeBudgetEuro(row) * (1 + ((row['ve_aliquota']?.valore ?? 0) / 100))
        },
        Utile: (state: any, getters: any) => (row: any) => {
            return getters.VeBudgetEuro(row) - getters.AcCostoTotaleEuro(row) + getters.AcCommissioneTotaleEuro(row)
        },
        CostoVenditaUnitario: (state: any, getters: any) => (row: any) => {
            if (row['ac_mark_up']?.length || row['ac_arrotondamento_costo_unitario']?.length) {
                const costo_unitario = getters.AcCostoUnitario(row)
                const markup = getters.AcMarkUp(row)
                const arr = getters.AcArrotondamentoCostoUnitario(row)
                const v = costo_unitario * (1 + markup / 100) / getters.valoreValuta(row['ve_valuta']) * getters.valoreValuta(row['ac_valuta']) + arr
                return v.toFixed(2)
            }
            return (row['ve_vendita_unitario'] ?? 0)
        },
        Mol: (state: any, getters: any) => (row: any) => {
            return getters.Utile(row) * 100 / getters.VeBudgetEuro(row)
        },
        isDescrizione: (state: any, getters: any) => (row: any) => {
            return row.type == TipoRigaPreventivo.DESCRIZIONE
        },
        isOpzionale: (state: any, getters: any) => (row: any) => {
            return row.type == TipoRigaPreventivo.OPZIONALE
        },
        isOfferta: (state: any, getters: any) => (row: any) => {
            return row.type == TipoRigaPreventivo.OFFERTA
        },


        /////////////////
        /////SEZIONI/////
        /////////////////
        TotaleBudgetProgettoSezione: (state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.VeBudgetEuro(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.VeBudgetEuro(curr_row);
                }
                return prev_val
            }, 0)
        },
        TotaleCostiSezione: (state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.AcCostoTotale(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.AcCostoTotale(curr_row);
                }
                return prev_val
            }, 0)
        },
        TotaleCostiEuroSezione: (state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.AcCostoTotaleEuro(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.AcCostoTotaleEuro(curr_row);
                }
                return prev_val
            }, 0)
        },
        TotaleCommissioniEuroSezione: (state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.AcCommissioneTotaleEuro(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.AcCommissioneTotaleEuro(curr_row);
                }
                return prev_val
            }, 0)
        },
        TotaleUtileEuroSezione: (state: any, getters: any) => (sezione: any) => {
            return getters.TotaleBudgetProgettoSezione(sezione) - getters.TotaleCostiEuroSezione(sezione) + getters.TotaleCommissioniEuroSezione(sezione)
        },
        TotaleMolSezione: (state: any, getters: any) => (sezione: any) => {
            return getters.TotaleUtileEuroSezione(sezione) * 100 / getters.TotaleBudgetProgettoSezione(sezione)
        },
        TotaleFeesSezione: (state: any, getters: any) => (sezione: any) => {
            return getters.FeesSezione(sezione).reduce((previousValue: number, currentValue: any) => {
                return previousValue + currentValue.valore * currentValue.budget
            }, 0) * 0.01
        },
        TotaleOreRisorseSezione:(state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.TotaleOreRisorsa(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.TotaleOreRisorsa(curr_row);
                }
                return prev_val
            }, 0)
        },
        TotaleCostoRisorseSezione:(state: any, getters: any) => (sezione: any) => {
            return sezione.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                if (curr_row.nuvole) {
                    return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                        return n_val + getters.AcCostoTotaleRisorsa(nuv)
                    }, 0)
                }
                if (!getters.isDescrizione(curr_row) && !getters.isOpzionale(curr_row)) {
                    return prev_val + getters.AcCostoTotaleRisorsa(curr_row);
                }
                return prev_val
            }, 0)
        },

        /////////////////////////
        /////TOTALI GENERALI/////
        /////////////////////////
        TotaleBudgetProgetto: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleBudgetProgettoSezione(sez)
            }, 0)  * (1 - getters.Sconto / 100)
        },
        TotaleBudgetProgettoConFee: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleBudgetProgetto(sezioni) + getters.TotaleFeesSezioni(sezioni)
        },
        TotaleRicaviProgetto: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleBudgetProgetto(sezioni) + getters.TotaleCommissioniProgetto(sezioni)
        },
        TotaleRicaviProgettoConFee: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleBudgetProgettoConFee(sezioni) + getters.TotaleCommissioniProgetto(sezioni)
        },
        TotaleUtiliProgetto: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleRicaviProgetto(sezioni) - getters.TotaleCostiEuroProgetto(sezioni)
        },
        TotaleUtiliProgettoConFee: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleRicaviProgettoConFee(sezioni) - getters.TotaleCostiEuroProgetto(sezioni)
        },
        TotaleFeesSezioni: (state: any, getters: any) => (sezioni: any) => {
            return getters.FeesSezioni(sezioni).reduce((previousValue: number, currentValue: any) => {
                return previousValue + currentValue.valore * currentValue.budget
            }, 0) * 0.01
        },
        TotaleCostiEuroProgetto: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleCostiEuroSezione(sez)
            }, 0)
        },
        TotaleCostiProgetto: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleCostiSezione(sez)
            }, 0)
        },
        TotaleCommissioniProgetto: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleCommissioniEuroSezione(sez);
            }, 0)
        },
        TotaleMolProgetto: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleUtiliProgetto(sezioni) * 100 / getters.TotaleRicaviProgetto(sezioni)
        },
        TotaleMolProgettoConFee: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleUtiliProgettoConFee(sezioni) * 100 / getters.TotaleRicaviProgettoConFee(sezioni)
        },
        Fees: (state: any, getters: any) => {
            return getters.FeesSezioni(getters.ActiveTab?.sezioni)
        },
        TotaleFees: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleFeesSezioni(sezioni)
        },
        TotaleOreRisorseProgetto: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleOreRisorseSezione(sez);
            }, 0)
        },
        TotaleCostoRisorseProgetto:(state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + getters.TotaleCostoRisorseSezione(sez);
            }, 0)
        },
        TotaleFeesConIva: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleFees(sezioni) * 1.22
        },

        FeesSezione: (state: any, getters: any) => (sezione: any, return_array?: any[]) => {
            const ret: any[] = return_array || []
            state.fees.forEach((fee: any, index: number) => {
                if (fee.valore != undefined) {
                    ret.push({
                        nome: fee.descrizione,
                        valore: fee.valore,
                        budget: 0
                    })
                }
            })
            const cb = function (row: any) {
                const record_fee = row['ve_fee']
                if (ret[record_fee]) {
                    ret[record_fee].budget += getters.VeBudgetEuro(row)
                }
            }
            if (sezione) {
                sezione.records.forEach((row: any, j: number) => {
                    if (row.nuvole) {
                        row.nuvole.forEach((nuvola: any, j: number) => {
                            cb(nuvola)
                        })
                    } else if(!(getters.isOpzionale(row) || getters.isDescrizione(row))) {
                        cb(row)
                    }
                })
            }
            return ret
        },
        FeesSezioni: (state: any, getters: any) => (sezioni: any) => {
            let ret: any[] = []
            if (sezioni) {
                sezioni.forEach((s: any, i: number) => {
                    ret = getters.FeesSezione(s, ret)
                })
            }
            return ret
        },
        TotaleRisorseInterne: (state: any, getters: any) => (sezioni: any) => {
            return sezioni.reduce((s_val: any, sez: any, s_idx: number) => {
                return s_val + sez.records.reduce((prev_val: any, curr_row: any, r_idx: number) => {
                    if (curr_row.nuvole) {
                        return prev_val + curr_row.nuvole.reduce((n_val: any, nuv: any, n_idx: number) => {
                            return n_val + getters.RisorseInterne(nuv)
                        }, 0)
                    }
                    return prev_val + getters.RisorseInterne(curr_row);
                }, 0)
            }, 0)
        },
        RisorseInterne: (state: any, getters: any) => (row: any) => {
            return (row['ac_unita'] ?? 0) * (row['ac_ovn_gg'] ?? 0) * (row['ac_qta'] ?? 0)
        },
        TotaleMol: (state: any, getters: any) => (sezioni: any) => {
            return getters.TotaleUtiliProgetto(sezioni) * 100 / getters.TotaleBudgetProgettoConFee(sezioni)
        },
        TotaleMolFee: (state: any, getters: any) => (sezioni: any) => {
            return (getters.TotaleRicaviProgetto(sezioni) - getters.TotaleCostiEuroProgetto(sezioni)) / (getters.TotaleRicaviProgetto(sezioni) + getters.TotaleFees(sezioni)) * 100
        },
        GetFirstValutaVendita: (state: any, getters: any) => {
            if (!getters.StessaValutaVendita) {
                return false;
            }
            if (getters.RecordSfusi.length) {
                return getters.RecordSfusi[0].ve_valuta
            }
            return undefined
        },
        StessaValutaVendita: (state: any, getters: any) => {
            let first: any = null
            return getters.RecordSfusi.every((value: any, index: number) => {
                if (index == 0) {
                    first = value.ve_valuta
                }
                return first == value.ve_valuta
            })
        },
    }
}

export default SottoprogettoDataManager;
